document.addEventListener('DOMContentLoaded', function () {
  initRevealObserver();
  initProductGallery();
  initVariantPicker();
  initAddToCart();
  initFaqAccordion();
  initCouponApply();
  initComparador();
  initProtectionGuard();
});

function initProtectionGuard() {
  var variantId = window.NC_PROTECTION_VARIANT_ID;
  if (!variantId) return;

  function clamp() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var line = cart.items.find(function (i) { return i.variant_id === variantId; });
        if (line && line.quantity > 1) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 1 }),
          }).then(function () {
            refreshCartBubble();
            window.location.reload();
          });
        }
      })
      .catch(function () {});
  }

  clamp();

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('.quantity__input[data-quantity-variant-id]')) {
      if (Number(el.getAttribute('data-quantity-variant-id')) === variantId) {
        setTimeout(clamp, 800);
      }
    }
  });
}

function refreshCartBubble() {
  fetch('/?sections=cart-icon-bubble')
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var html = data && data['cart-icon-bubble'];
      if (!html) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var fresh = doc.getElementById('cart-icon-bubble');
      var current = document.getElementById('cart-icon-bubble');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    })
    .catch(function () {});
}

function initComparador() {
  var comparadores = document.querySelectorAll('[data-nc-comparador]');
  comparadores.forEach(function (el) {
    var antesLayer = el.querySelector('[data-nc-comparador-antes]');
    var linea = el.querySelector('[data-nc-comparador-linea]');
    var handle = el.querySelector('[data-nc-comparador-handle]');
    var range = el.querySelector('[data-nc-comparador-range]');
    if (!antesLayer || !range) return;

    function setWidthVar() {
      el.style.setProperty('--nc-comparador-ancho', el.offsetWidth + 'px');
    }
    setWidthVar();
    window.addEventListener('resize', setWidthVar);

    function setPosition(pct) {
      pct = Math.max(0, Math.min(100, pct));
      antesLayer.style.width = pct + '%';
      if (linea) linea.style.left = pct + '%';
      if (handle) handle.style.left = pct + '%';
      range.value = pct;
    }

    function pctFromClientX(clientX) {
      var rect = el.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    var dragging = false;
    el.addEventListener('pointerdown', function (e) {
      dragging = true;
      setPosition(pctFromClientX(e.clientX));
      el.setPointerCapture(e.pointerId);
    });
    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPosition(pctFromClientX(e.clientX));
    });
    el.addEventListener('pointerup', function () { dragging = false; });
    el.addEventListener('pointercancel', function () { dragging = false; });

    range.addEventListener('input', function () {
      setPosition(Number(range.value));
    });
  });
}

function initCouponApply() {
  var buttons = document.querySelectorAll('[data-nc-coupon-apply]');
  buttons.forEach(function (btn) {
    var wrap = btn.closest('.nc-promo__card');
    var input = wrap ? wrap.querySelector('[data-nc-coupon-input]') : null;
    var status = wrap ? wrap.querySelector('[data-nc-coupon-status]') : null;
    if (!input) return;

    btn.addEventListener('click', function () {
      var code = input.value.trim();
      if (!code) return;

      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-nc-coupon-loading');
      if (status) status.textContent = '';

      fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' })
        .then(function () {
          btn.textContent = btn.getAttribute('data-nc-coupon-done');
          if (status) status.textContent = "Code applied — you'll see it at checkout.";
          refreshCartBubble();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-nc-coupon-idle');
          if (status) status.textContent = 'Something went wrong. Please try again.';
        });
    });
  });
}

function initRevealObserver() {
  var items = document.querySelectorAll('.nc-reveal');
  if (!items.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    items.forEach(function (el) { el.classList.add('nc-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nc-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  // Safety net: if IntersectionObserver never fires for some reason (blocked,
  // unsupported, non-rendering context), content must never stay hidden.
  setTimeout(function () {
    items.forEach(function (el) { el.classList.add('nc-visible'); });
  }, 2500);

  items.forEach(function (el) { observer.observe(el); });
}

function initProductGallery() {
  var galleries = document.querySelectorAll('[data-nc-gallery]');
  galleries.forEach(function (gallery) {
    var main = gallery.querySelector('[data-nc-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-nc-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full-src');
        if (!fullSrc) return;
        main.src = fullSrc;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

function initVariantPicker() {
  var forms = document.querySelectorAll('[data-nc-product-form]');
  forms.forEach(function (formWrap) {
    var variantsJson = formWrap.querySelector('[data-nc-variants-json]');
    if (!variantsJson) return;

    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }

    var pillGroups = formWrap.querySelectorAll('[data-nc-option-index]');
    var idInput = formWrap.querySelector('[data-nc-variant-id]');
    var priceEl = formWrap.querySelector('[data-nc-price]');
    var comparePriceEl = formWrap.querySelector('[data-nc-compare-price]');
    var submitBtn = formWrap.querySelector('[data-nc-submit]');
    var submitText = formWrap.querySelector('[data-nc-submit-text]');
    var sectionEl = formWrap.closest('.nc-producto') || document;
    var galleryMain = sectionEl.querySelector('[data-nc-gallery-main]');
    var galleryThumbs = sectionEl.querySelectorAll('[data-nc-gallery-thumb]');

    function getSelectedOptions() {
      var selected = [];
      pillGroups.forEach(function (group) {
        var active = group.querySelector('.is-selected');
        selected.push(active ? active.getAttribute('data-value') : null);
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateUI() {
      var selected = getSelectedOptions();
      var variant = findVariant(selected);
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
      }
      if (submitText) {
        submitText.textContent = variant.available ? submitText.getAttribute('data-add-text') : submitText.getAttribute('data-sold-out-text');
      }
      if (galleryMain && variant.featured_image && variant.featured_image.src) {
        galleryMain.src = variant.featured_image.src;
        galleryThumbs.forEach(function (thumb) {
          var thumbSrc = (thumb.getAttribute('data-full-src') || '').split('?')[0];
          var variantSrc = variant.featured_image.src.split('?')[0];
          thumb.classList.toggle('is-active', thumbSrc === variantSrc);
        });
      }
    }

    pillGroups.forEach(function (group) {
      var pills = group.querySelectorAll('[data-nc-pill]');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          pills.forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          updateUI();
        });
      });
    });

    updateUI();
  });
}

function initAddToCart() {
  var forms = document.querySelectorAll('[data-nc-product-form]');
  forms.forEach(function (formWrap) {
    var form = formWrap.tagName === 'FORM' ? formWrap : formWrap.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();

      var idInput = form.querySelector('[data-nc-variant-id]') || form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;

      var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];

      var protectionToggle = formWrap.querySelector('[data-nc-protection-toggle]');
      if (protectionToggle && protectionToggle.checked) {
        items.push({ id: parseInt(protectionToggle.getAttribute('data-variant-id'), 10), quantity: 1 });
      }

      var submitBtn = formWrap.querySelector('[data-nc-submit]');
      var submitText = formWrap.querySelector('[data-nc-submit-text]');
      var viewCartBtn = formWrap.querySelector('[data-nc-view-cart]');
      var originalText = submitText ? submitText.textContent : null;
      if (submitBtn) submitBtn.disabled = true;
      if (submitText) submitText.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            window.alert(data.description || data.message || 'This product is currently unavailable.');
            if (submitBtn) submitBtn.disabled = false;
            if (submitText && originalText) submitText.textContent = originalText;
            return;
          }
          if (submitText) submitText.textContent = 'Added ✓';
          if (viewCartBtn) viewCartBtn.hidden = false;
          refreshCartBubble();
          setTimeout(function () {
            if (submitBtn) submitBtn.disabled = false;
            if (submitText && originalText) submitText.textContent = originalText;
          }, 1600);
        })
        .catch(function () {
          window.alert('Something went wrong adding this to your cart. Please try again.');
          if (submitBtn) submitBtn.disabled = false;
          if (submitText && originalText) submitText.textContent = originalText;
        });
    });
  });
}

function initFaqAccordion() {
  var lists = document.querySelectorAll('[data-nc-faq]');
  lists.forEach(function (list) {
    var items = list.querySelectorAll('details');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  });
}
